document.querySelectorAll(".is-style-toggle-button").forEach(function (button) {
  button.addEventListener("click", function () {
    // If this button is currently open (details visible)
    if (button.dataset.opened === "true") {
      closeToggleDetails(button);
    } else {
      // First, close any other open details and restore their buttons
      closeAllOpenToggles(button);

      // Find the associated details element
      let details;
      // Look up from the closest group container
      let parentGroup = button.closest(".wp-block-group");
      if (parentGroup) {
        let sibling = parentGroup.nextElementSibling;
        while (sibling) {
          if (sibling.classList.contains("toggle-details")) {
            details = sibling;
            break;
          }
          sibling = sibling.nextElementSibling;
        }
      }
      // If not found, try the previous sibling (if button was already moved)
      if (!details) {
        details = button.previousElementSibling;
        if (!details || !details.classList.contains("toggle-details")) {
          console.warn("Details element not found for toggle button");
          return;
        }
      }

      // Show the details
      details.classList.add("toggle-details-visible");

      // Store the button's original parent and next sibling (for later restoration)
      if (!button._originalParent) {
        button._originalParent = button.parentNode;
        button._originalNextSibling = button.nextElementSibling;
      }

      // Move the button after the details element
      details.parentNode.insertBefore(button, details.nextElementSibling);

      // Mark the button as open and apply a "filled" style class
      button.dataset.opened = "true";
      button.classList.add("filled");
    }
  });
});

// Add click event listeners to all toggle-button-wrap elements
document.querySelectorAll(".toggle-button-wrap").forEach(function (wrapper) {
  wrapper.addEventListener("click", function (event) {
    // Only process if the click was directly on the wrapper (not on its children)
    if (event.target === wrapper) {
      // Close all open toggle details
      closeAllOpenToggles();
    }
  });
});

// Function to close a specific toggle details
function closeToggleDetails(button) {
  // Find the associated details element (it should be the previous sibling)
  let details = button.previousElementSibling;
  if (
    details &&
    details.classList.contains("toggle-details") &&
    details.classList.contains("toggle-details-visible")
  ) {
    details.classList.remove("toggle-details-visible");
  }
  // Restore the button to its original position, if stored
  if (button._originalParent) {
    if (button._originalNextSibling) {
      button._originalParent.insertBefore(button, button._originalNextSibling);
    } else {
      button._originalParent.appendChild(button);
    }
  }
  // Remove the open state and filled style
  button.dataset.opened = "false";
  button.classList.remove("filled");
}

// Function to close all open toggle details except the current one (if provided)
function closeAllOpenToggles(currentButton = null) {
  document
    .querySelectorAll(".is-style-toggle-button")
    .forEach(function (otherButton) {
      if (
        otherButton.dataset.opened === "true" &&
        otherButton !== currentButton
      ) {
        closeToggleDetails(otherButton);
      }
    });
}

document.addEventListener("DOMContentLoaded", function () {
  if (document.body.classList.contains("single")) {
    const newsMenuItem = document.querySelector(".news-page");
    if (newsMenuItem) {
      newsMenuItem.classList.add("current-menu-item");
    }
  }
});

// Add this script to your WordPress site (in your theme's JS file, or via a custom HTML block)
document.addEventListener("DOMContentLoaded", function () {
  // Select all details elements on the page
  const allDetails = document.querySelectorAll("details");

  // Add click event listener to each summary element (the header part of details)
  allDetails.forEach((details) => {
    const summary = details.querySelector("summary");
    if (summary) {
      summary.addEventListener("click", (event) => {
        // Prevent the default toggle behavior to handle it manually
        event.preventDefault();

        // If the clicked details is already open, just close it
        if (details.hasAttribute("open")) {
          details.removeAttribute("open");
          return;
        }

        // Close all details elements
        allDetails.forEach((item) => {
          item.removeAttribute("open");
        });

        // Open only the clicked details
        details.setAttribute("open", "");
      });
    }
  });
});
